import React from "react";
import "./PortfolioSelectBox.scss";
import classnames from "classnames";
import { isEmpty } from "lodash";
import { portfolioMetadataMap } from "utils/individualPortfolioHelper";

interface Portfolio {
  name?: string;
  label?: string;
  key?: string;
  description?: string;
  portfolio?: string;
  portfolioName?: string;
}

interface PortfolioMetadata {
  label?: string;
  risk?: string;
  portfolio?: string;
  stock?: string;
  bond?: string;
  description?: string;
  key?: string;
}

interface Props {
  portfolio?: Portfolio;
  isSelected?: boolean;
  onSelect?: (portfolio: Portfolio) => void;
  isRecommendedPortoflio?: boolean;
}

const PortfolioSelectBox = ({
  portfolio = {},
  isSelected,
  isRecommendedPortoflio,
  onSelect,
}: Props) => {
  const { portfolioName } = portfolio;

  const portfolioMetadata = portfolioMetadataMap[
    portfolioName as keyof typeof portfolioMetadataMap
  ] as PortfolioMetadata | undefined;
  if (isEmpty(portfolio) || isEmpty(portfolioMetadata)) return null;
  return (
    <div className="portfolio-selection-box">
      <div
        className="portfolio-select-box-container"
        onClick={() => {
          onSelect!(portfolio);
        }}
      >
        <div
          className={classnames("portfolio-select-box ", {
            selected: isSelected,
          })}
        >
          <div className="portfolio">
            <p className="type">{portfolioMetadata.portfolio}</p>
            {isRecommendedPortoflio && (
              <p className="recommended-portfolio">{"Recommended"}</p>
            )}
          </div>

          <div className="risk">
            <p className="portfolio-risk">{portfolioMetadata.risk}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioSelectBox;
